module.exports = __webpack_public_path__ + "static/img/logo_tf88.a6f285c8.png";